<!-- //
侧边树组件（不包含任何业务功能，需要业务功能再次封装，比如ApiGroup）
@auth xuyd
@date 2024-05-01
//-->
<template>
  <div style="height: 100%;position: relative;">
    <div v-show="showBar" style="height: 100%;" :style="{width: width + 'px'}">
      <div class="flex-row" style="padding-bottom: 5px">
        <el-input size="small" v-model="searchVal" placeholder="关键字搜索" class="input-append" clearable>
          <el-button size="small" slot="append" type="primary" @click="handleAdd" style="width: 60px; margin: -10px -25px" v-if="editMode">添加</el-button>
        </el-input>
      </div>
      <el-scrollbar class="scroll-container">
        <el-tree ref="refTree"
                 :data="groupList"
                 :props="props"
                 :show-checkbox="false"
                 :expand-on-click-node="!props.folderClick"
                 :node-key="nodeKey"
                 :filter-node-method="filterNode"
                 :current-node-key="currentNodeKey"
                 :default-expanded-keys="defaultExpandedKeys"
                 :highlight-current="true"
                 @node-expand="handleNodeExpand"
                 @node-collapse="handleNodeCollapse"
                 @node-click="handleNodeClick"
        >
          <div class="custom-tree-node" slot-scope="{data, node}">
            <div class="content">
              <template v-if="data.children && data.children.length > 0">
                <i class="el-icon-folder"></i>
              </template>
              <template v-else>
                <i v-if="props.leafIcon" :class="'el-icon-' + props.leafIcon"></i>
              </template>
              <span class="ml5">{{ node.label }}</span>
              <span v-if="props.hasCount">
                ({{ data[props.countProp] ? data[props.countProp] : 0 }})
              </span>
              <div class="opts" v-if="editMode">
                <el-button v-if="data.id !== '0'"
                           type="text"
                           size="small"
                           icon="el-icon-more"
                           @click.stop="handleGroupMenu(data, $event)"/>
                <el-button v-else
                           size="small"
                           type="text"
                           icon="el-icon-refresh"
                           @click.stop="handleRefreshGroupMenu(data, $event)"/>
              </div>
            </div>
          </div>
        </el-tree>
      </el-scrollbar>
      <AddGroupDlg ref="refAddGroupDlg" :options="props" :data-list="groupList" @open="handleOpen" @confirm="handleConfirm" @close="handleClose">
        <template slot-scope="{options, dataList}">
          <slot :options="options" :data-list="dataList">
          </slot>
        </template>
      </AddGroupDlg>
      <ContextMenu ref="refContextMenu" :data-list="groupList" @command="handleMenuCmd"/>
    </div>
    <CollapseBar v-model="showBar" position="left" style="position: absolute; right: 0; top: 50%;" class="collapse"/>
  </div>
</template>

<script>
import ContextMenu from './ctx-menu'
import AddGroupDlg from './detail-wrapper'

const DEFAULT_PROPS = {
  children: 'children',
  label: 'label',
  hasCount: false,
  countProp: 'count',
  leafIcon: "document", // 叶子节点icon显示文件夹（folder）/文件（document）/空（""）
  folderClick: false, // 目录是否能
  maxLevel: -1, // 默认不限层级(root的手动添加虚拟不包含，节点的level从0开始
};
export default {
  name: 'CompSideTree',
  components: {ContextMenu, AddGroupDlg},
  data() {
    return {
      showBar: true,
      searchVal: null,
      groupList: [],
      currentNode: null,
      currentNodeKey: '0', // el-ui无监听，需要手动处理
      defaultExpandedKeys: ['0'],// el-ui有监听，只要设置此值即可
      expandedKeys: ['0'],
      props: this.$util.mergeObject(DEFAULT_PROPS, this.defaultProps)
    }
  },
  props: {
    width: {
      type: Number,
      default: 200,
    },
    nodeKey: {
      type: String,
      default: 'id',
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    defaultCurrentNode: {
      type: String,
      default: 'root', // [root：根节点|first：第一条业务数据]
    },
    load: Function,
    defaultProps: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  watch: {
    searchVal(val) {
      this.$refs.refTree.filter(val);
    },
    groupList(val) {
      this.$nextTick(() => {
        this.$refs.refTree.setCurrentKey(this.currentNodeKey);
      })
    }
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      this.load().then(data => {
        this.groupList = data;
        let ids = [];
        if (this.currentNodeKey !== '0') {
          let nodeData = this.$util.getTreeNode(this.groupList, this.currentNodeKey);
          ids = this.getNodeAllIds(nodeData);
        } else {
          if(this.defaultCurrentNode === 'first') {  // 要求实际的第一个节点
            // 判断目录可否点击，如果可以点击，则获取第一个，如果不可点击，则获取第一个叶子节点
            let firstNode = this.getFirstNode(this.groupList, this.props.folderClick);
            if(firstNode) {
              this.currentNodeKey = firstNode.id;
              ids = [this.currentNodeKey];
            }
            this.defaultExpandedKeys = [this.currentNodeKey];
            ids = [this.currentNodeKey];
          }
        }
        this.$emit('change', ids);
      });
    },
    /**
     * 获取第一个节点，如果有虚root节点，则从下一个开始，没有则第一个
     *
     * @param treeList
     * @param includeFolder
     */
    getFirstNode(treeList, includeFolder) {
      if(!treeList || treeList.length <= 0) {
        return null;
      }
      // 遍历list，返回第一个
      let loop = function(list, includeFolder) {
        if(!list || list.length <= 0) {
          return null;
        }
        if(includeFolder) {// 可以包含目录
          return list[0];
        } else {// 只能叶子
          for(let item of list) {// 不循环，（暂时无此循环需求）
            if(item.children && item.children.length > 0) {
              return loop(item.children, includeFolder);
            } else {
              return item;
            }
          }
        }
      };

      if(treeList[0].parentId === '-1') {// 有虚拟root
        return loop(treeList[0].children, includeFolder);
      } else {
        return loop(treeList, includeFolder);
      }
    },

    handleNodeExpand(nodeData, node) {
      if (!this.expandedKeys.includes(nodeData.id)) {
        this.expandedKeys.push(nodeData.id);
      }
      this.defaultExpandedKeys = [...this.expandedKeys];
    },
    handleNodeCollapse(nodeData, node) {
      const index = this.expandedKeys.indexOf(nodeData.id);
      if (index > -1) {
        this.expandedKeys.splice(index, 1);
      }
      this.removeChildrenIds(nodeData);
      this.defaultExpandedKeys = [...this.expandedKeys];
    },
    removeChildrenIds(nodeData) {
      if (nodeData && nodeData.children) {
        nodeData.children.forEach(item => {
          const index = this.expandedKeys.indexOf(item.id);
          if (index >= 0) {
            this.expandedKeys.splice(index, 1);
          }
          this.removeChildrenIds(item);
        });
      }
    },
    getNodeAllIds(nodeData) {
      let arr = [];
      if (nodeData) {
        arr.push(nodeData.id);
      }
      if (nodeData && nodeData.children) {
        nodeData.children.forEach(item => {
          arr.push(...this.getNodeAllIds(item));
        })
      }
      return arr;
    },
    filterNode(val, data) {
      if (!val) return true;
      return data[this.props.label].indexOf(val) !== -1;
    },

    // 点击节点
    handleNodeClick(nodeData) {
      this.currentNode = nodeData;
      this.currentNodeKey = nodeData.id;
      let ids = [];
      if (this.currentNodeKey !== '0') {
        ids = this.getNodeAllIds(nodeData);
      }
      console.log("----change------>", nodeData, JSON.stringify(ids));
      if(nodeData.children && nodeData.children.length > 0) {
        if(this.props.folderClick) {
          this.$emit('change', {ids, nodeData});
        }
      } else {
        this.$emit('change', {ids, nodeData});
      }
      this.$refs.refContextMenu.closeMenu();
    },
    handleAdd() {
      this.$refs.refAddGroupDlg.showModal({
        title: '添加',
        mode: 1,
        data: {...this.currentNode},
        onOk: (data) => {
          this.reload();
        }
      });
    },
    handleEdit(rowData) {
      this.$refs.refAddGroupDlg.showModal({
        title: '编辑',
        mode: 2,
        data: {...rowData},
        onOk: (data) => {
          this.reload();
        }
      });
    },
    /**
     * 对话框确定
     */
    handleOpen(data) {
      let component = this.$parent.$refs.refGroupDetail
      if(!component) {// 外部没有定义，则使用内部默认
        component = this.$refs.refAddGroupDlg.$refs.refGroupDetail;
      }
      component && component.handleOpen(data);
    },
    /**
     * 对话框确定
     */
    handleConfirm(resolve) {
      let component = this.$parent.$refs.refGroupDetail
      if(!component) {// 外部没有定义，则使用内部默认
        component = this.$refs.refAddGroupDlg.$refs.refGroupDetail;
      }
      component && component.handleConfirm().then(data => {
        this.$emit('save', data, resolve);
      });
    },
    /**
     * 对话框取消
     */
    handleClose() {
      let component = this.$parent.$refs.refGroupDetail
      if(!component) {// 外部没有定义，则使用内部默认
        component = this.$refs.refAddGroupDlg.$refs.refGroupDetail;
      }
      component && component.handleClose();
    },

    /**
     * 刷新
     * @param item
     * @param e
     */
    handleRefreshGroupMenu(item, e) {
      this.load().then(data => {
        this.groupList = data;
      });
    },
    handleGroupMenu(item, e) {
      const menuMinWidth = 100;
      const offsetLeft = this.$el.getBoundingClientRect().left;
      const offsetWidth = this.$el.offsetWidth;
      const maxLeft = offsetWidth - menuMinWidth + offsetLeft;
      const eventX = e.clientX;
      let left;
      if (eventX > maxLeft) {
        left = maxLeft;
      } else {
        left = eventX;
      }
      let top = e.clientY;
      console.log("----handleGroupMenu------>", item);
      this.$refs.refContextMenu.openMenu({left: left, top: top, rowData: item})
    },
    // 菜单处理
    handleMenuCmd(command, nodeData) {
      console.log("----handleMenuCmd------>", command, JSON.stringify(nodeData.id));
      switch (command) {
        case 'up':
          this.$refs.refContextMenu.closeMenu();
          new Promise(resolve => this.$emit('up', nodeData.id, resolve)).then(retData => {
            this.reload();
          });
          break;
        case 'down':
          this.$refs.refContextMenu.closeMenu();
          new Promise(resolve => this.$emit('down', nodeData.id, resolve)).then(retData => {
            this.reload();
          });
          break;
        case 'edit':
          this.$refs.refContextMenu.closeMenu();
          this.handleEdit(nodeData);
          break;
        case 'delete':
          this.$refs.refContextMenu.closeMenu();
          this.$modal.confirm(`请确认是否删除该分组？`).then(() => {
            new Promise(resolve => this.$emit('delete', nodeData.id, resolve)).then(retData => {
              this.$modal.msgSuccess('删除成功');
              this.reload();
            });
          });
          break;
      }
    }
  }
}
</script>
<style lang="less" scoped>
.input-append {
  :deep(.el-input-group__append) {
    background-color: #1e47ab;
    color: #FFFFFF;
  }
}

.scroll-container {
  height: calc(100% - 37px);
  box-sizing: border-box;

  .el-scroller__wrap {
    overflow-x: hidden;
    overflow-y: scroll;
  }

  :deep(.el-tree-node__content) {
    height: 36px;
  }

  :deep(.el-tree-node__content):hover .opts {
    display: inline-block;
  }

  .custom-tree-node {
    width: 100%;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .opts {
      display: none;
      position: absolute;
      right: 10px;
    }

    .content {
      display: flex;
      align-items: center;
    }
  }
}
</style>
